import React, { useState } from "react"
import Modal from "../../../../components/Modal"
import RadioInput from "../../../User/getAllUsers/components/RadioInput"
import TextInput from "../../../User/getAllUsers/components/TextInput"
import DateInput from "../../../User/getAllUsers/components/DateInput"
import { TAcampaignNames } from "../../../../services/campaignsAPI"

interface FiltersProps {
  isOpen: boolean
  onClose: () => void
  handleFetchData: () => void
  filters: any
  setFilters: (filters: any) => void
}

const Filters: React.FC<FiltersProps> = ({
  isOpen,
  onClose,
  handleFetchData,
  filters,
  setFilters,
}) => {
  const [campaignNames, setCampaignNames] = useState<any[]>([])
  const [isCampaignNamesOpen, setIsCampaignNamesOpen] = useState(false)

  const getCampaignNames = async (name: string) => {
    try {
      const response = await TAcampaignNames(name)
      setCampaignNames(response.campaigns)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      {isOpen && (
        <div className="flex w-full items-center justify-center">
          <Modal
            classname="fixed inset-0 bg-gray-800 bg-opacity-50 p-3 flex items-center justify-end z-50"
            classname2="relative bg-white rounded-3xl w-full md:w-1/2 h-auto"
            onClick={onClose}
          >
            <div className="w-full p-4 h-full overflow-y-auto overscroll-contain">
              <div className="w-full">
                <h2 className="font-semibold text-2xl">Filtrele</h2>
                <div className="border"></div>
              </div>

              {/* Campaign Name Filter */}
              <div className="flex flex-col w-full justify-between items-center gap-4 mt-3 mb-3">
                <TextInput
                  value={filters.campaignName || ""}
                  setValue={(e) => {
                    setFilters({ ...filters, campaignName: e })
                    getCampaignNames(e)
                    setIsCampaignNamesOpen(true)
                  }}
                  placeholder="Kampanya Adı"
                />
                {campaignNames?.length > 0 && filters.campaignName && (
                  <ul
                    className="absolute z-10 left-4 right-0 top-28 mt-1 bg-white border border-gray-200 rounded shadow-lg max-h-60 overflow-y-auto"
                    style={{
                      display: isCampaignNamesOpen ? "block" : "none",
                    }}
                  >
                    {campaignNames.slice(0, 5).map((campaign) => (
                      <li
                        key={campaign._id}
                        onClick={() => {
                          setFilters({ ...filters, campaignName: campaign.name })
                          setIsCampaignNamesOpen(false)
                        }}
                        className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 cursor-pointer"
                      >
                        {campaign.name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Last Action Date Range Filter */}
              <div className="flex w-full justify-between items-center gap-4 mt-3">
                <DateInput
                  value={filters.last_action_at_start || ""}
                  setValue={(e) => setFilters({ ...filters, last_action_at_start: e })}
                  placeholder="Son değişiklik Başlangıç Tarihi"
                />
              </div>
              <div className="flex w-full justify-between items-center gap-4 mt-3">
                <DateInput
                  value={filters.last_action_at_end || ""}
                  setValue={(e) => setFilters({ ...filters, last_action_at_end: e })}
                  placeholder="Son değişiklik Bitiş Tarihi"
                />
              </div>
              <div className="mb-3">
                <div className="text-xs text-gray-600 mb-2">Hızlı Filtreler:</div>
                <div className="flex flex-wrap gap-2">
                  {[
                    { label: "Son 1 hafta", days: 7 },
                    { label: "Son 1 ay", days: 30 },
                    { label: "Son 3 ay", days: 90 },
                    { label: "Son 6 ay", days: 180 },
                    { label: "Son 1 yıl", days: 365 },
                  ].map((filter) => (
                    <button
                      key={filter.label}
                      onClick={() => {
                        const startDate = new Date()
                        startDate.setDate(startDate.getDate() - filter.days)
                        setFilters({
                          ...filters,
                          content_shared_date: startDate,
                        })
                      }}
                      className="px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors"
                    >
                      {filter.label}
                    </button>
                  ))}
                  <button
                    onClick={() => {
                      const startOfYear = new Date(new Date().getFullYear(), 0, 1)
                      setFilters({
                        ...filters,
                        content_shared_date: startOfYear,
                      })
                    }}
                    className="px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors"
                  >
                    Bu yıl
                  </button>
                  <button
                    onClick={() => {
                      setFilters({
                        ...filters,
                        content_shared_date: null,
                      })
                    }}
                    className="px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded hover:bg-gray-200 transition-colors"
                  >
                    Temizle
                  </button>
                </div>
              </div>

              {/* Platform Filter */}
              <div className="flex w-full justify-between items-center gap-4 mt-3">
                <RadioInput
                  placeholder="Platform"
                  value={filters.platform || ""}
                  onChange={(e) => setFilters({ ...filters, platform: e })}
                  option1="insta-story"
                  option2="insta-reels"
                  option3="insta-post"
                  option4="tiktok"
                  option5="ugc"
                  label1="Insta Story"
                  label2="Insta Reels"
                  label3="Insta Post"
                  label4="TikTok"
                  label5="UGC"
                />
              </div>

              <div
                className="flex flex-row justify-between w-full mt-24 py-4 space-x-24"
                style={{
                  boxShadow: "0px -12px 20px -10px rgba(0, 0, 128, 0.1)",
                }}
              >
                <button
                  className="text-blue h-12 rounded-full"
                  onClick={() =>
                    setFilters({
                      campaignName: "",
                      platform: "",
                      last_action_at_start: "",
                      last_action_at_end: "",
                    })
                  }
                >
                  Temizle
                </button>
                <button
                  className="text-blue bg-blue-100 h-12 px-4 rounded-full"
                  onClick={() => {
                    handleFetchData()
                    onClose()
                  }}
                >
                  <span>Uygula</span>
                </button>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </>
  )
}

export default Filters
